/* eslint-disable no-unused-vars */
import React, { useState } from 'react'
import styles from './styles.module.scss'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { ReactComponent as PtFileIcon } from '../../../../../assets/icons/file_pt.svg'
import { ReactComponent as StomatologyIcon } from '../../../../../assets/icons/stomatology.svg'
import { ReactComponent as PulmonologyIcon } from '../../../../../assets/icons/pulmonology.svg'
import { useTranslation } from 'react-i18next'

const index = ({ close }) => {
  const { t } = useTranslation()
  const { appointments } = useSelector((state) => state.appointments)
  const { patients } = useSelector((state) => state.patients)
  const [searchInput, setSearchInput] = useState('')
  const [searchCategory, setSearchCategory] = useState(['stomatology', 'pulmonology'])
  const [activeTab, setActiveTab] = useState('all') // 'all', 'paid', 'unpaid'

  const handleCategoryChange = (newCat) => {
    if (searchCategory?.includes(newCat)) {
      setSearchCategory(searchCategory.filter((cat) => cat !== newCat))
    } else {
      setSearchCategory([...searchCategory, newCat])
    }
  }

  const patientsWithApts = patients
    .filter((pt) => pt?.appointments?.length)
    ?.map((pt) => {
      const apts = appointments.filter((apt) => pt?.appointments?.includes(apt.id))
      const allPaid = apts?.reduce((acc, apt) => {
        // For pulmonology, use patient_pay if available, otherwise use paid_amount
        if (apt.category === 'pulmonology') {
          return acc + (Number(apt?.patient_pay) || Number(apt?.paid_amount) || 0)
        }
        return acc + (Number(apt?.paid_amount) || 0)
      }, 0)
      const allPrice = apts?.reduce((acc, apt) => {
        // For pulmonology, use service_cost if available, otherwise use price
        if (apt.category === 'pulmonology') {
          return acc + (Number(apt?.service_cost) || Number(apt?.price) || 0)
        }
        return acc + (Number(apt?.price) || 0) * (Number(apt?.unit_multiplier) || 1)
      }, 0)
      const allDebt = allPrice - allPaid
      const isFullyPaid = allPaid >= allPrice
      return {
        ...pt,
        fullApts: apts,
        allPaid,
        allPrice,
        allDebt,
        isFullyPaid
      }
    })
    ?.sort((a, b) => b?.allDebt - a?.allDebt)

  const progressColorGenerator = (progress) => {
    if (progress >= 1 || isNaN(progress)) return 'green'
    if (progress < 0.5) return 'red'
    return 'orange'
  }

  const filteredPts = patientsWithApts?.filter((pt) => {
    const searchInputLower = searchInput.toLowerCase()
    const opNameLower = pt.full_name?.toLowerCase()
    const opCategoryLower = pt.category.toLowerCase()
    const matchesSearch = (searchCategory?.includes(opCategoryLower) || searchCategory.length === 0) &&
      (opNameLower?.includes(searchInputLower) || searchInputLower === '')
    
    // Filter by payment status
    if (activeTab === 'paid') {
      return matchesSearch && pt.isFullyPaid
    } else if (activeTab === 'unpaid') {
      return matchesSearch && !pt.isFullyPaid
    }
    return matchesSearch
  })

  return (
    <div className={styles.popup_wrapper}>
      <div className={styles.form_header}>
        <h2 className={styles.header_text}>{t('paying_patients')}</h2>
        <button className={styles.close_btn} onClick={close}>
          ✖
        </button>
      </div>
      <div className={styles.op_menu_search}>
        <input
          className={styles.op_menu_search_input}
          value={searchInput}
          placeholder={t('search')}
          onChange={(e) => setSearchInput(e.target.value)}
        />
        <button
          className={`${styles.op_category_search_btn} ${searchCategory.includes('stomatology') ? styles.active : ''}`}
          type='button'
          onClick={() => handleCategoryChange('stomatology')}
        >
          <StomatologyIcon className={styles.btn_icon_sto} />
        </button>

        <button
          className={`${styles.op_category_search_btn} ${searchCategory.includes('pulmonology') ? styles.active : ''}`}
          type='button'
          onClick={() => handleCategoryChange('pulmonology')}
        >
          <PulmonologyIcon className={styles.btn_icon_pul} />
        </button>
      </div>

      <div className={styles.tabs_container}>
        <button 
          className={`${styles.tab_button} ${activeTab === 'all' ? styles.active : ''}`}
          onClick={() => setActiveTab('all')}
        >
          {t('all')}
        </button>
        <button 
          className={`${styles.tab_button} ${activeTab === 'paid' ? styles.active : ''}`}
          onClick={() => setActiveTab('paid')}
        >
          {t('paid')}
        </button>
        <button 
          className={`${styles.tab_button} ${activeTab === 'unpaid' ? styles.active : ''}`}
          onClick={() => setActiveTab('unpaid')}
        >
          {t('unpaid')}
        </button>
      </div>

      <ul className={styles.popup_pt_List}>
        {filteredPts?.map((pt) => {
          const { allDebt, allPaid, allPrice } = pt
          const progress = allPrice === 0 ? 1 : allPaid / allPrice
          const barColor = progressColorGenerator(progress)
          return (
            <li className={styles.pt_pay_card} key={pt.id}>
              <span className={styles.pt_name}>{pt.full_name}</span>
              <div className={styles.progress_bar}>
                <span
                  className={styles.progress}
                  style={{
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    width: `${progress * 100}%`,
                    background: barColor,
                    height: '100%'
                  }}
                />
                <span 
                  className={styles.progress_text}
                  style={{
                    color: barColor === 'green' ? 'white' : 'black',
                    textShadow: barColor === 'green' ? '0 0 2px rgba(0, 0, 0, 0.3)' : '0 0 2px rgba(255, 255, 255, 0.8)'
                  }}
                >
                  {allPaid + '€ /' + allPrice + '€'}
                </span>
              </div>
              <Link onClick={close} to={`/management/${pt.category}/patient/${pt.id}`} className={styles.pt_link}>
                <PtFileIcon />
              </Link>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
export default index
